import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router } from '@angular/router';
import { FeatureFlagsService } from '@coin/shared/core/data-access';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentGuard {
  private router = inject(Router);
  private featureFlagService = inject(FeatureFlagsService);

  canMatch(route: Route): boolean {
    const { featureFlag } = (route as ActivatedRouteSnapshot).data;
    if (!featureFlag || (featureFlag && this.featureFlagService.isActive(featureFlag))) {
      return true;
    }
    this.router.navigate(['']);
    return false;
  }
}
